import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    LeadCaptureModel,
    ShareLCTApiParameter,
    ShareLCTParameter,
    shareLCTService,
} from "@tCentro/Services/CENSubmitLeadCaptureService";

type HandlerType = ApiHandlerDiscreteParameter<ShareLCTParameter, ShareLCTApiParameter, LeadCaptureModel>;

export const PopulateApiParameter: HandlerType = props => {
    const leadCaptureModel = props.parameter as LeadCaptureModel;
    props.apiParameter = { leadCaptureModel };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await shareLCTService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitLeadCaptureForm = createHandlerChainRunner(chain, "CENShareArtice");
export default submitLeadCaptureForm;
